import {User} from '../models/users/user.model';

export namespace Users {
  export class GetUsers {
    static readonly type = '[Users api] Get Users';

    constructor(public force: boolean = false) {
    }
  }

  export class GetUser {
    static readonly type = '[Users api] Get User';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class UpdateUser {
    static readonly type = '[Users api] Create User';

    constructor(public user: User) {
    }
  }

  export class CreateUser {
    static readonly type = '[Users api] Update User';

    constructor(public user: User) {
    }
  }

  export class DeleteUser {
    static readonly type = '[Users api] Delete User';

    constructor(public user: User) {
    }
  }
}
